import React, { useState } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import CopyIcon from '@material-ui/icons/FileCopyOutlined';
import IconButton from '@material-ui/core/IconButton';
import Avatar from '@material-ui/core/Avatar';
import Snackbar from '@material-ui/core/Snackbar';
import CloseIcon from '@material-ui/icons/Close';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import MoreIcon from "@material-ui/icons/MoreVert";
import firebase, { auth, db, storage } from "../settings/firebase";
import Divider from "@material-ui/core/Divider";
import Follow from "./Follow";
import './FollowList.css';

const useStyles = ((theme) => ({
  followitem: {
    display: "flex",
    justifyContent: "center",
    textAlign: "center",
    alignItems: "center",
    flexDirection: "column",
  },
  followitemdiv: {
    display: "flex",
    textAlign: "left",
    justifyContent: "center",
    alignItems: "center",
  }
}))
// フォローアイテム
function FollowItem (props) {
  const { data, nowuid } = props;
  const classes = useStyles;

  return (
    <div className={classes.followitem}>
      <div style={{display: "flex", alignItems: "center",  justifyContent: "center", textAlign: "center", maxWidth: "900px", width: "100%"}}>
        <Avatar alt={data.displayid} src={data.avatarUrl}></Avatar>
        <div className={classes.followitemdiv}
          style={{textAlign: "left", marginLeft: "1em", flexGrow: "1"}}
        >
          <p>{data.name} @{data.displayid}</p>
        </div>
        {nowuid === data.uid? null: <Follow followuid={data.uid} style={{marginTop: ".3em"}} />}
      </div>
      <Divider />
    </div>
  )
}

// フォローリストポップアップ
export default class FollowList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {data: [], nowuid: ""};
    this.componentDidMount = this.componentDidMount.bind(this);
    this.componentWillUnmount = this.componentWillUnmount.bind(this);
  }
  _isMounted = false; //unmountを判断（ローディング判定用）

  async componentDidMount() {
    await auth.onAuthStateChanged(async user => {
      if (user) {
        const userDocs = await db.collection("users").get();
        if(this.props.type === "follow") {
          let followinglist = [];
          await db.collection("follows").doc(this.props.uid).onSnapshot(doc => {
            if (doc.exists) {
              // console.log(doc.data())
              doc.data().following.forEach(following => {
                let flw = {uid: following.uid};
                userDocs.forEach(userdoc => {
                  if(userdoc.id === following.uid) {
                    flw.avatarUrl = userdoc.data().avatarUrl;
                    flw.name = userdoc.data().name;
                    flw.displayid = userdoc.data().displayid;
                    flw.ts = following.ts;
                  }
                })
                followinglist.unshift(flw);
              })
            }
            console.log(followinglist);
            this.setState({data: followinglist, nowuid: user.uid});
          })
  
        } else if (this.props.type === "follower") {
          let followerlist = [];
          db.collection("follows").onSnapshot(docs => {
            docs.forEach(doc => {
              if (doc.exists) {
                console.log(doc.data())
                // console.log(doc.data())
                doc.data().following.forEach(following => {
                  if (following.uid === this.props.uid) {
                    let flw = {uid: doc.id};
                    userDocs.forEach(userdoc => {
                      if(userdoc.id === doc.id) {
                        flw.avatarUrl = userdoc.data().avatarUrl;
                        flw.name = userdoc.data().name;
                        flw.displayid = userdoc.data().displayid;
                        flw.ts = following.ts;
                      }
                    })
                    followerlist.unshift(flw);
                  }
                })
              }
            })
            console.log(followerlist);
            this.setState({data: followerlist, nowuid: user.uid});
          })
        }
      }
    })
    this._isMounted =true;
  }
  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const type = this.props.type;
    console.log(type)
    let list = [];
    let keynum = 0
    this.state.data.forEach(item => {
      list.unshift(<FollowItem key={'notif-' + keynum} data={item} nowuid={this.state.nowuid} />);
      keynum += 1;
    })
    return (
      <div className='popup'>
        <div className='popup_inner'>
          <h1>{type === "follow"? <>フォロー中</>: type === "follower"? <>フォロワー</>: null}</h1>
          {list}
          <Button type="button" variant="contained" color="primary" onClick={this.props.closelist}>
            閉じる
          </Button>
        </div>
      </div>
    );
  }
}
